import * as ACTION_TYPES from '../types';

let initialState = {
  leadList: [],
  lead: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_LEADS:
        return {...state, leadList: action.data };

      case ACTION_TYPES.DELETE_LEAD:
        let newList = state.leadList.filter(lead => lead._id !== action.id);
        return {...state, leadList: newList };
      
      case ACTION_TYPES.GET_LEAD_BY_ID:
        return {...state, lead: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_LEAD:
        return {...state, leadList: []};

      default:
        return state;
    }
  };